<h1>{{ currentTitle }}</h1>

<div [nbSpinner]="loading()" nbSpinnerStatus="danger" nbSpinnerSize="large">

@if (registrationChecked && !registrationOpen) {
  <div class="registration-closed">
    <p class="bold uppercase">{{ 'teams.sign_up.registrations_closed' | translate }}</p>
    <p>{{ 'teams.sign_up.registrations_closed_message' | translate }}</p>
    <app-league-centered></app-league-centered>
  </div>
}

@if (registrationChecked && registrationOpen && !submitted) {
  <app-league [season]="nextSeason?.name"></app-league>

  <form class="form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">

    @if (currentStep == 1) {
      <p>{{ 'teams.sign_up.get_signed_up' | translate: { season: nextSeason?.name } }}</p>

      <p class="bold">{{ 'teams.sign_up.change_note' | translate }}</p>

      <app-league-centered></app-league-centered>

      <p class="bold mt-30 mb-30">
        {{ 'teams.sign_up.low_tier_info' | translate }}<br>
        <a [href]="lowTierInfoDocUrl" target="_blank">
          {{ 'teams.sign_up.low_tier_label' | translate }}
        </a>
      </p>

      <span><span class="primary">*</span> {{ 'teams.sign_up.mandatory_indicator' | translate }}</span>

      <div class="form-group mt-40">
        <label for="team_name">{{ 'teams.sign_up.team_name' | translate }} *</label>
        <input id="team_name" nbInput type="text" formControlName="team_name">
        @if (registerForm.controls['team_name'].invalid && (registerForm.controls['team_name'].touched || registerForm.controls['team_name'].dirty)) {
          @if (registerForm.controls['team_name'].errors?.['required']) {
            <span class="error-message">{{ 'common.mandatory' | translate }}</span>
          }
        }
      </div>

      <div class="form-group">
        <label for="team_manager_name">{{ 'teams.sign_up.team_manager' | translate }} *</label>
        <input id="team_manager_name" nbInput type="text" formControlName="team_manager_name">
        @if (registerForm.controls['team_manager_name'].invalid && (registerForm.controls['team_manager_name'].touched || registerForm.controls['team_manager_name'].dirty)) {
          @if (registerForm.controls['team_manager_name'].errors?.['required']) {
            <span class="error-message">{{ 'common.mandatory' | translate }}</span>
          }
        }
      </div>

      <div class="form-group">
        <label for="team_account_x">{{ 'teams.sign_up.team_twitter' | translate }}</label>
        <input id="team_account_x" nbInput type="text" formControlName="team_account_x">
      </div>

      <div class="form-group">
        <label for="captain_email">{{ 'teams.sign_up.captain_email' | translate }} *</label>
        <input id="captain_email" nbInput type="email" formControlName="captain_email">
        @if (registerForm.controls['captain_email'].invalid && (registerForm.controls['captain_email'].touched || registerForm.controls['captain_email'].dirty)) {
          @if (registerForm.controls['captain_email'].errors?.['required']) {
            <span class="error-message">{{ 'common.mandatory' | translate }}</span>
          }
        }
      </div>

      <div class="form-group">
        <label for="captain_account_x">{{ 'teams.sign_up.captain_twitter' | translate }}</label>
        <input id="captain_account_x" nbInput type="text" formControlName="captain_account_x">
      </div>

      <div class="form-group">
        <label for="captain_account_discord">{{ 'teams.sign_up.captain_discord' | translate }}</label>
        <input id="captain_account_discord" nbInput type="text" formControlName="captain_account_discord">
      </div>

      <h2 class="section-title">{{ 'teams.sign_up.preferred_division' | translate }}</h2>
      <p>{{ 'teams.sign_up.preferred_division_help' | translate }}</p>

      <div class="preferred_divisions">
        @for (division of preferredDivisions; track division.division_id) {
          <label>
            <input type="radio" [value]="division.division_id" formControlName="preferred_division"/>
            {{ division.name.replace('Division', 'Div') }}
            @if (division.next_season_prizepool) {
              - Max Sign up Prizepool - <span class="primary ml-5">£{{ division.next_season_prizepool | number:'1.0-0' }}</span><span class="ml-5">{{ 'teams.sign_up.prior_boosted' | translate }}</span>
            }
          </label>
        }
      </div>
      @if (registerForm.controls['preferred_division'].invalid && (registerForm.controls['preferred_division'].touched || registerForm.controls['preferred_division'].dirty)) {
        @if (registerForm.controls['preferred_division'].errors?.['required']) {
          <span class="error-message">{{ 'common.mandatory' | translate }}</span>
        }
      }

      <h2 class="section-title">{{ 'teams.sign_up.players_activision' | translate }}</h2>

      <div class="players_activision_id">
        <div class="form-group">
          <label for="player_1_account_activision">{{ 'teams.sign_up.player_captain' | translate }} *</label>
          <input id="player_1_account_activision" nbInput type="text" formControlName="captain_account_activision">
          @if (registerForm.controls['captain_account_activision'].invalid && (registerForm.controls['captain_account_activision'].touched || registerForm.controls['captain_account_activision'].dirty)) {
            @if (registerForm.controls['captain_account_activision'].errors?.['required']) {
              <span class="error-message">{{ 'common.mandatory' | translate }}</span>
            }
            @if (registerForm.controls['captain_account_activision'].errors?.['minlength']) {
              <span class="error-message">{{ 'teams.sign_up.activision_length' | translate: { min: activisionMinLength, max: activisionMaxLength } }}</span>
            }
          }
        </div>

        @for (n of [2, 3, 4, 5, 6]; track n) {
          <div class="form-group">
            <label [for]="'player_' + n + '_account_activision'">{{ 'teams.sign_up.player_n' | translate: { n: n } }}</label>
            <input [id]="'player_' + n + '_account_activision'" nbInput type="text" [formControlName]="'player_' + n + '_account_activision'">
          </div>
        }
      </div>

      <div class="form-navbar mt-40">
        <span></span>
        <button class="app-button" type="button" [disabled]="registerForm.invalid" (click)="next()">{{ 'common.next' | translate }}</button>
      </div>
    }

    @else {
      <p class="warning-message">{{ 'teams.sign_up.for_new_players' | translate }}</p>

      <p class="mt-20">{{ 'teams.sign_up.new_player_description' | translate }}</p>

      <app-league-centered></app-league-centered>

      <span><span class="primary">*</span> {{ 'teams.sign_up.mandatory_indicator' | translate }}</span>

      <div class="form-group">
        <label for="cmg_account">{{ 'teams.sign_up.cmg_accounts' | translate }}</label>
        <br>
        <span class="normal basic ml-15">{{ 'teams.sign_up.cmg_link_note' | translate }}</span>
        <input id="cmg_account" nbInput type="text" formControlName="cmg_account">
      </div>

      <p class="mt-30 left uppercase">
        {{ 'teams.sign_up.rules_agree' | translate }} <span class="primary uppercase">*</span>
      </p>

      <div id="terms-and-conditions" class="form-group ml-30">
        <label><input type="checkbox" formControlName="i_agree" required> {{ 'teams.sign_up.i_agree' | translate }}</label>
        @if (registerForm.controls['i_agree'].invalid && (registerForm.controls['i_agree'].touched || registerForm.controls['i_agree'].dirty)) {
          @if (registerForm.controls['i_agree'].hasError('required')) {
            <span class="error-message">{{ 'common.mandatory' | translate }}</span>
          }
        }
      </div>

      <p class="mt-30 left uppercase">
        {{ 'teams.sign_up.understand_registration' | translate }} <span class="primary">*</span>
        <app-league-centered></app-league-centered>
      </p>

      <div class="form-group ml-30">
        <label><input type="checkbox" formControlName="i_understand" required> {{ 'teams.sign_up.i_understand' | translate }}</label>
        @if (registerForm.controls['i_understand'].invalid && (registerForm.controls['i_understand'].touched || registerForm.controls['i_understand'].dirty)) {
          @if (registerForm.controls['i_understand'].hasError('required')) {
            <span class="error-message">{{ 'common.mandatory' | translate }}</span>
          }
        }
      </div>

      <div class="form-navbar mt-40">
        <button class="app-button basic" type="button" (click)="back()">{{ 'common.back' | translate }}</button>
        <button class="app-button" type="submit" [disabled]="registerForm.invalid">{{ 'common.send' | translate }}</button>
      </div>
    }

  </form>
}

@if (submitted && submittedData) {
  <div class="confirmation">
    <app-league [season]="nextSeason?.name"></app-league>

    <div class="confirmation-header">
      <h2>{{ 'teams.sign_up.registration_submitted' | translate }}</h2>
      <p class="activation-notice">
        {{ 'teams.sign_up.no_account' | translate }}
      </p>
    </div>

    <div class="recap">
      <h3 class="section-title">{{ 'teams.sign_up.summary' | translate }}</h3>

      <div class="recap-section">
        <h4>{{ 'teams.sign_up.team_label' | translate }}</h4>
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.team_name' | translate }}</span>
          <span class="recap-value">{{ submittedData.team_name }}</span>
        </div>
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.manager_label' | translate }}</span>
          <span class="recap-value">{{ submittedData.team_manager_name }}</span>
        </div>
        @if (submittedData.team_account_x) {
          <div class="recap-row">
            <span class="recap-label">{{ 'teams.sign_up.team_twitter' | translate }}</span>
            <span class="recap-value">{{ submittedData.team_account_x }}</span>
          </div>
        }
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.division_label' | translate }}</span>
          <span class="recap-value">{{ preferredDivisionLabel() }}</span>
        </div>
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.season_label' | translate }}</span>
          <span class="recap-value primary">{{ nextSeason?.name }}</span>
        </div>
      </div>

      <div class="recap-section">
        <h4>{{ 'teams.sign_up.captain_label_full' | translate }}</h4>
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.captain_email' | translate }}</span>
          <span class="recap-value">{{ submittedData.captain_email }}</span>
        </div>
        <div class="recap-row">
          <span class="recap-label">{{ 'auth.account.activision_id' | translate }}</span>
          <span class="recap-value">{{ submittedData.captain_account_activision }}</span>
        </div>
        @if (submittedData.captain_account_discord) {
          <div class="recap-row">
            <span class="recap-label">{{ 'teams.sign_up.captain_discord' | translate }}</span>
            <span class="recap-value">{{ submittedData.captain_account_discord }}</span>
          </div>
        }
        @if (submittedData.captain_account_x) {
          <div class="recap-row">
            <span class="recap-label">{{ 'teams.sign_up.captain_twitter' | translate }}</span>
            <span class="recap-value">{{ submittedData.captain_account_x }}</span>
          </div>
        }
      </div>

      @if (activisionPlayers().length > 1) {
        <div class="recap-section">
          <h4>{{ 'teams.sign_up.players_label' | translate }}</h4>
          @for (player of activisionPlayers(); track $index) {
            <div class="recap-row">
              <span class="recap-label">{{ 'teams.sign_up.player_n_label' | translate: { n: $index + 1 } }}{{ $index === 0 ? ' (' + ('teams.sign_up.captain_label_full' | translate) + ')' : '' }}</span>
              <span class="recap-value">{{ player }}</span>
            </div>
          }
        </div>
      }

      @if (submittedData.cmg_account) {
        <div class="recap-section">
          <h4>{{ 'teams.sign_up.additional_info' | translate }}</h4>
          <div class="recap-row">
            <span class="recap-label">{{ 'teams.sign_up.cmg_account_label' | translate }}</span>
            <span class="recap-value">{{ submittedData.cmg_account }}</span>
          </div>
        </div>
      }

      <div class="recap-section">
        <h4>{{ 'teams.sign_up.agreements' | translate }}</h4>
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.rules_agreed' | translate }}</span>
          <span class="recap-value">{{ submittedData.i_agree ? ('common.yes' | translate) : ('common.no' | translate) }}</span>
        </div>
        <div class="recap-row">
          <span class="recap-label">{{ 'teams.sign_up.conditions_understood' | translate }}</span>
          <span class="recap-value">{{ submittedData.i_understand ? ('common.yes' | translate) : ('common.no' | translate) }}</span>
        </div>
      </div>
    </div>

    <app-league-centered></app-league-centered>
  </div>
}

</div><!-- /nbSpinner wrapper -->

<div class="mt-50"></div>

<app-contact [hideTitle]="true"></app-contact>
